// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import KonvoChannelScratchpad, {
	type ChannelPadLock,
	type ChannelPadPayload,
} from '@app/features/konvo_scratchpad/state/KonvoChannelScratchpad';

export function handleKonvoChannelScratchpadUpdate(data: ChannelPadPayload, _context: GatewayHandlerContext): void {
	if (!data || typeof data.channel_id !== 'string' || typeof data.content !== 'string') return;
	// Only pads somebody has opened are tracked; the rest load fresh when opened.
	KonvoChannelScratchpad.peek(data.channel_id)?.applyRemote(data);
}

export function handleKonvoChannelScratchpadLocks(
	data: {channel_id?: string; locks?: Array<ChannelPadLock>},
	_context: GatewayHandlerContext,
): void {
	if (!data || typeof data.channel_id !== 'string' || !Array.isArray(data.locks)) return;
	KonvoChannelScratchpad.peek(data.channel_id)?.applyLocks(data.locks);
}
